export default function (cli) {
  return {
    list (shopPk, date) {
      return cli.get(`${cli.apiEndpoint}hotpepper-mails/capacities/`).query({
        shop: shopPk,
        date: date,
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/hotpepper-mails.js